import Constants from "config/Constants";
import useHyroxBannerEligibility from "components/Banners/hooks/useHyroxBannerEligibility";

const VISIBLE_ON_PAGE = [Constants.routes.home.route, Constants.routes.athletes.route, Constants.routes.live.route];

function useHyroxConditioningTestBannerEligibility(): boolean {
  return useHyroxBannerEligibility(VISIBLE_ON_PAGE);
}

export default useHyroxConditioningTestBannerEligibility;
